import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { leadListsApi } from "../../../libs/landvoice-api";
import {
  getNsSavedSearchCacheKey,
  getNsSavedSearchDetailsCacheKey,
  getNsSavedSearchStatusCacheKey,
  NS_LIST_SAVED_SEARCHES_CACHE_KEY,
  NS_INFINITE_LIST_SAVED_SEARCHES_CACHE_KEY,
  NS_SAVED_SEARCH_CACHE_KEY
} from "../constants/cacheKeys";

export const useDeleteSavedSearchMutation = (): UseMutationResult<
  void,
  Error,
  { listId: string; searchName: string }
> => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, { listId: string; searchName: string }>({
    mutationKey: ["NS_DELETE_SAVED_SEARCH_MUTATION"],
    mutationFn: async ({
      listId,
    }: {
      listId: string;
      searchName: string; // Used for success message, not API call
    }) => {
      await leadListsApi.deleteList(listId);
    },
    onSuccess: (_, { listId }) => {
      // Remove all caches related to this specific search
      queryClient.removeQueries({
        queryKey: getNsSavedSearchCacheKey(listId),
      });
      queryClient.removeQueries({
        queryKey: getNsSavedSearchDetailsCacheKey(listId),
      });
      queryClient.removeQueries({
        queryKey: getNsSavedSearchStatusCacheKey(listId),
      });

      // Invalidate all saved searches lists to refresh the UI
      queryClient.invalidateQueries({
        queryKey: [NS_LIST_SAVED_SEARCHES_CACHE_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [NS_INFINITE_LIST_SAVED_SEARCHES_CACHE_KEY],
      });

      // Invalidate all saved search caches to ensure consistency
      queryClient.invalidateQueries({
        queryKey: [NS_SAVED_SEARCH_CACHE_KEY],
      });
    },
  });
};